<template>
  <div>
    <tableComponent
      ref="tableComponent"
      :tableSettings="tableSettings"
      :tableData="tableData"
      :headers="headers"
      :enable-row-clickable="true"
      @newDocument="newDocument"
      @clickedRow="openInstructionCategory($event)"
      @openMultiUserDialog="openMultiUserDialog"
    />
    <multiUserDialog
      v-model="multiUserOpen"
      entityType="instructionCategory"
      :availableItems="transferItems"
      itemText="name"
      itemValue="_id"
      :clients="transferClients"
      :currentClientId="currentClientId"
      @confirm="executeTransfer"
      entityLabel="multiUser.dialog.instructionCategories"
    />
  </div>
</template>
<script>
import { getUniqueId } from "../../components/api/api";
import tableComponent from "../../components/_utils/dataTableHelpers/tableComponent.vue";
import multiUserDialog from "../../components/_utils/dataTableHelpers/actions/multiUserDialog.vue";

export default {
  components: {
    tableComponent,
    multiUserDialog,
  },
  data: () => ({
    tableSettings: {
      title: "",
      showSelect: false,
      showHeaderToolbar: true,
      headerButtons: [
        {
          title: "multiUser.button",
          color: "primary",
          action: "openMultiUserDialog",
          icon: "mdi-swap-horizontal",
          iconDark: true,
          dark: true,
        },
        {
          title: "operatingInstructions.category.new",
          color: "secondary",
          action: "newDocument",
          icon: "add",
          iconDark: true,
          dark: true,
          outlined: true,
        },
      ],
      multipleSelectButtons: [],
    },
    counts: {},
    currentClientId: "",
    isMultiUser: false,
    multiUserOpen: false,
    transferClients: [],
    transferItems: [],
  }),
  async created() {
    const user = await this.$store.dispatch("getUserInfo");
    this.currentClientId = user?.client?._id || "";
    this.isMultiUser = user?.role === "MultiUser";

    const res = await this.$store.dispatch("getAllInstructionCategories");
    this.transferItems = res.data || res;

    this.fetchCounts();

    if (!this.isMultiUser) {
      this.tableSettings.headerButtons =
        this.tableSettings.headerButtons.filter(
          (btn) => btn.action !== "openMultiUserDialog"
        );
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("operatingInstructions.category.tableHeader.name"),
          value: "name",
          align: "left",
        },
        {
          text: this.$t("folderCount.total"),
          value: "folderTotal",
          align: "center",
          sortable: false,
        },
        {
          text: "",
          value: "instructionCategoryAction",
          align: "right",
          sortable: false,
        },
      ];
    },
    tableData() {
      return {
        tableComponentSlots: [
          {
            id: getUniqueId(),
            slotName: "item.folderTotal",
            componentName: "folderCount",
            config: { kind: "total", counts: this.counts },
          },
          {
            id: getUniqueId(),
            slotName: "item.instructionCategoryAction",
            componentName: "instructionCategoryAction",
          },
        ],
        itemKey: "id",
        uriPartPrepend: "instructionCategory",
        uriPartAppend: "",
        populate: [],
        sort: "-createdAt",
        editFormPushName: "instructionCategoryForm",
        detailViewPushName: "operatingInstruction",
      };
    },
  },
  methods: {
    reloadDataFunc() {
      this.$refs.tableComponent.getData();
      this.fetchCounts();
    },
    async fetchCounts() {
      this.counts =
        (await this.$store.dispatch("getInstructionCategoryCounts")) || {};
    },
    newDocument() {
      this.$router.push({
        name: this.tableData.editFormPushName,
        params: { id: "1", mode: "new", data: 1 },
      });
    },
    openInstructionCategory(event) {
      this.$router.push({
        name: this.tableData.detailViewPushName,
        params: {
          instructionCategoryId: event.id,
          instructionCategoryName: event.name,
        },
      });
    },

    async openMultiUserDialog() {
      try {
        const res = await this.$store.dispatch("getTransferClients");
        this.transferClients = res.data || [];
      } catch (e) {
        return;
      }
      this.multiUserOpen = true;
    },

    async executeTransfer(payload) {
      try {
        const result = await this.$store.dispatch("transferEntities", payload);

        const parts = [];
        if (result.totalSuccess > 0) {
          parts.push(
            this.$t("multiUser.result.success", {
              number: result.totalSuccess,
            })
          );
        }
        if (result.totalConflict > 0) {
          parts.push(
            this.$t("multiUser.result.error", {
              number: result.totalConflict,
            })
          );
        }
        if (result.totalError > 0) {
          parts.push(
            this.$t("multiUser.result.error", { number: result.totalError })
          );
        }

        this.$store.commit("CREATE_SNACKBAR", parts.join(" · "));

        if (payload.action === "move" && result.totalSuccess > 0) {
          this.reloadDataFunc();
        }
      } catch (e) {
        console.error("Transfer failed:", e);
      }
    },
  },
};
</script>
